export default {"src":"/_next/static/media/portfolio-catapult-header-dark-theme.2cac4e23.svg","height":100,"width":330};